import { render, staticRenderFns } from "./EditClaimForm.vue?vue&type=template&id=01495da8&scoped=true"
import script from "./EditClaimForm.vue?vue&type=script&lang=ts"
export * from "./EditClaimForm.vue?vue&type=script&lang=ts"
import style0 from "./EditClaimForm.vue?vue&type=style&index=0&id=01495da8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01495da8",
  null
  
)

export default component.exports